export default __webpack_public_path__ + "static/media/logo-calamba.d1472ac7.jpeg";